import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/ServicePeriods/hooks/useServicePeriodInstances.ts
function useServicePeriodInstances(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : !!args;
	const { call, data, error, isCalling, success } = useRPC(RPCs.ServicePeriods.FindServicePeriodInstances.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire
	});
	return {
		call,
		data,
		error,
		isCalling,
		success
	};
}
//#endregion
export { useServicePeriodInstances };

//# sourceMappingURL=useServicePeriodInstances.js.map